import type { ReactNode } from 'react';
import './SectionHeader.css';

/** DESIGN.md §10 SectionHeader: serif title, optional sub line and a ghost action. */
export function SectionHeader({
  title,
  sub,
  action,
  level = 2,
  id,
}: {
  title: string;
  sub?: ReactNode;
  action?: ReactNode;
  level?: 2 | 3;
  id?: string;
}) {
  const Heading = level === 2 ? 'h2' : 'h3';
  return (
    <div className="section-header">
      <div>
        <Heading className="section-header__title" id={id}>
          {title}
        </Heading>
        {sub && <p className="section-header__sub">{sub}</p>}
      </div>
      {action && <div className="section-header__action">{action}</div>}
    </div>
  );
}

/** Overline label for groups inside lists (store sections, ingredient groups, settings groups). */
export function GroupLabel({
  children,
  action,
  as: Tag = 'h3',
  id,
}: {
  children: ReactNode;
  action?: ReactNode;
  as?: 'h2' | 'h3' | 'h4' | 'div';
  id?: string;
}) {
  if (!action) {
    return (
      <Tag className="group-label" id={id}>
        {children}
      </Tag>
    );
  }
  return (
    <div className="group-label">
      <Tag className="group-label__text" id={id}>
        {children}
      </Tag>
      {action}
    </div>
  );
}
